 
const ConsignmentActions = (props) => {
    const handleRouteClick = (e) => {
        e.stopPropagation();
        // console.log("MAP Icon ", props)
        // props.context.componentParent.onCloseUploadDiv(e);
        // props.context.componentParent.onCloseRouteDiv(e);
        props.context.onShowTransitGPS(props);
    };

    return (
            <a onClick={handleRouteClick}  title="GPS"><i className="icofont icofont-social-google-map f20"></i> </a>
        
    );
};

export default ConsignmentActions;
